/**
 * Partners store
 */
import { pick } from 'lodash';

/* @ts-expect-error ts-migrate(7016) FIXME: Untyped import */
import createStore from 'vendor/cnpm/fluxible.v0-4/addons/createStore';

const PartnersStore = createStore({
  storeName: 'PartnersStore',

  handlers: {
    RECEIVE_FEATURED_PARTNER_ID: '_receiveFeaturedPartnerId',
  },

  initialize() {
    this.featuredPartnerId = null;
  },

  _receiveFeaturedPartnerId(featuredPartnerId: number) {
    this.featuredPartnerId = featuredPartnerId;
    this.emitChange();
  },

  getFeaturedPartnerId() {
    return this.featuredPartnerId;
  },

  getState() {
    return pick(this, ['featuredPartnerId']);
  },

  dehydrate() {
    return this.getState();
  },

  rehydrate(state: { featuredPartnerId: number | null }) {
    this.featuredPartnerId = state.featuredPartnerId;
  },
});

export default PartnersStore;
